export const GtTypes = [
    {
        label: 'Student',
        value: 'Student'
    },
    {
        label: 'Employee',
        value: 'Employee'
    },
    {
        label: 'Cooperator',
        value: 'Cooperator'
    },
    {
        label: 'hsealumni',
        value: 'hsealumni'
    },
    {
        label: 'Hseyerevanstudent',
        value: 'Hseyerevanstudent'
    },
    {
        label: 'lpuemployee',
        value: 'lpuemployee'
    },
    {
        label: 'greenawards',
        value: 'greenawards'
    },
    {
        label: 'externalhse',
        value: 'externalhse'
    },
    {
        label: 'Hsecreativestudent',
        value: 'Hsecreativestudent'
    },
    {
        label: 'ranepa',
        value: 'ranepa'
    },
]

export const GtTypesFr = [
    {
        label: 'intuitlab-paris',
        value: 'intuitlab-paris'
    },
    {
        label: 'intuitlab-marseille',
        value: 'intuitlab-marseille'
    },
    // {
    //     label: 'intuitlab-saopaulo',
    //     value: 'intuitlab-saopaulo'
    // },
    {
        label: 'intuitlab-mumbai',
        value: 'intuitlab-mumbai'
    },
    {
        label: 'intuitlab-delhi',
        value: 'intuitlab-delhi'
    },
    {
        label: 'intuitlab-kolkata',
        value: 'intuitlab-kolkata'
    },
    // {
    //     label: 'intuitlab-dubai',
    //     value: 'intuitlab-dubai'
    // },
    // {
    //     label: 'intuitlab-shanghai',
    //     value: 'intuitlab-shanghai'
    // },
    {
        label: 'intuitlab-bengaluru',
        value: 'intuitlab-bengaluru'
    }
]
export const GtTypes = [
    {
        label: 'Student',
        value: 'Student'
    },
    {
        label: 'Employee',
        value: 'Employee'
    },
    {
        label: 'Cooperator',
        value: 'Cooperator'
    },
    {
        label: 'hsealumni',
        value: 'hsealumni'
    },
    {
        label: 'Hseyerevanstudent',
        value: 'Hseyerevanstudent'
    },
    {
        label: 'lpuemployee',
        value: 'lpuemployee'
    },
    {
        label: 'greenawards',
        value: 'greenawards'
    },
    {
        label: 'externalhse',
        value: 'externalhse'
    },
    {
        label: 'Hsecreativestudent',
        value: 'Hsecreativestudent'
    },
    {
        label: 'ranepa',
        value: 'ranepa'
    },
]

export const GtTypesFr = [
    {
        label: 'intuitlab-paris',
        value: 'intuitlab-paris'
    },
    {
        label: 'intuitlab-marseille',
        value: 'intuitlab-marseille'
    },
    // {
    //     label: 'intuitlab-saopaulo',
    //     value: 'intuitlab-saopaulo'
    // },
    {
        label: 'intuitlab-mumbai',
        value: 'intuitlab-mumbai'
    },
    {
        label: 'intuitlab-delhi',
        value: 'intuitlab-delhi'
    },
    {
        label: 'intuitlab-kolkata',
        value: 'intuitlab-kolkata'
    },
    // {
    //     label: 'intuitlab-dubai',
    //     value: 'intuitlab-dubai'
    // },
    // {
    //     label: 'intuitlab-shanghai',
    //     value: 'intuitlab-shanghai'
    // },
    {
        label: 'intuitlab-bengaluru',
        value: 'intuitlab-bengaluru'
    }
]
